import React from 'react';
import { Field, FormSpy } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';

export type WhenFieldChangesProps<F = unknown, T = unknown> = {
  field: string;
  becomes: F;
  set: string;
  to: T;
};

// Code snippet taken from:
// https://codesandbox.io/s/52q597j2p?file=/src/index.js:177-203
const WhenFieldChanges = ({
  field,
  becomes,
  set,
  to,
}: WhenFieldChangesProps) => (
  <Field name={set} subscription={{}}>
    {(
      // No subscription. We only use Field to get to the change function
      { input: { onChange } }
    ) => (
      <FormSpy subscription={{}}>
        {() => (
          <OnChange name={field}>
            {(value) => {
              if (value === becomes) {
                onChange(to);
              }
            }}
          </OnChange>
        )}
      </FormSpy>
    )}
  </Field>
);

export default WhenFieldChanges;
